import React from 'react';
import SMMonthCalendarRow from 'components/dashboard/calendar/SMMonthCalendarRow';
import PropTypes from 'prop-types';

class SMMonthCalendar extends React.Component {
  
  render() {
    let calendarRows = [],
        column_count = 7;
        
    if (this.props.items.length == 0) {
      return null;
    } else {
      for (let i=0; i < Math.ceil(this.props.items.length / column_count); i++) {
        let j = i * column_count;
        calendarRows.push(<SMMonthCalendarRow
          key={'calendarrow-'+i}
          room={this.props.room}
          plan={this.props.plan}
          delegate={this.props.delegate}
          items={this.props.items.slice(j, j + column_count)} 
          today={this.props.today}
          selectedCalendar={this.props.selectedCalendar} />);
      }
      
      return(
        <table className="dashboard-calendar__table mb15">
          <tbody>
            <tr>
              <th className="is-holiday">日</th>
              <th className=""><div className="dashboard-calendar__cell-wrap">月</div></th>
              <th className=""><div className="dashboard-calendar__cell-wrap">火</div></th>
              <th className=""><div className="dashboard-calendar__cell-wrap">水</div></th>
              <th className=""><div className="dashboard-calendar__cell-wrap">木</div></th>
              <th className=""><div className="dashboard-calendar__cell-wrap">金</div></th>
              <th className="is-holiday">土</th>
            </tr>
            {calendarRows}
          </tbody>
        </table>
      );
    }
  }
}
SMMonthCalendar.propTypes = {
  items: PropTypes.array.isRequired,
  today: PropTypes.instanceOf(Date).isRequired,
  room: PropTypes.object,
  plan: PropTypes.object,
  delegate: PropTypes.object,
  selectedCalendar: PropTypes.number
};

export default SMMonthCalendar;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/calendar/SMMonthCalendar.jsx